import axios, { AxiosResponse, InternalAxiosRequestConfig, AxiosError } from "axios";
import { API_URL } from "config/api";

const apiClient = axios.create({
  baseURL: API_URL,
});

const logOnDev = (message: string, log?: AxiosResponse | InternalAxiosRequestConfig | AxiosError) => {
  if (process.env.NODE_ENV === "development") {
    console.log(message, log);
  }
};

apiClient.interceptors.request.use((request) => {
  request.headers["x-app-version"] = "widget";
  return request;
});

apiClient.interceptors.response.use(
  (response) => {
    const { method, url } = response.config;
    const { status } = response;

    logOnDev(`✨ [${method?.toUpperCase()}] ${url} | Response ${status}`, response);

    return response;
  },
  (error) => {
    const { message } = error;
    const { status, data } = error.response;
    const { method, url } = error.config;
    console.log(error, "error", status);

    logOnDev(`🚨 [${method?.toUpperCase()}] ${url} | Error ${status} ${data?.message || ""} | ${message}`, error);

    return Promise.reject(error);
  },
);

export default apiClient;
